import React from 'react';
import styles from './WordCount.module.css';

interface WordCountProps {
  document: {
    words: number;
    characters: number;
  };
  selection: {
    words: number;
    characters: number;
  } | null;
}

const WordCount: React.FC<WordCountProps> = ({ document, selection }) => {
  const words = selection
    ? `${selection.words} of ${document.words}`
    : `${document.words}`;
  const characters = selection
    ? `${selection.characters} of ${document.characters}`
    : `${document.characters}`;

  return (
    <div className={styles.wordCountContainer}>
      <div className={styles.wordCountRow}>
        <div>Words</div>
        <div className={styles.count}>{words}</div>
      </div>
      <div className={styles.wordCountRow}>
        <div>Characters</div>
        <div className={styles.count}>{characters}</div>
      </div>
    </div>
  );
};

export default WordCount;
